import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: '/meus-dados',
  name: 'MeusDados',
  component: function component() {
    return import(/* webpackChunkName: "contrato" */'./pages/MeusDados');
  },
  meta: {
    titulo: 'Meus Dados',
    precisaAutenticacao: true,
    cabecalho: true,
    rodape: true
  }
}];